import * as types from './types';
import { has } from 'lodash';

const INITIAL_STATE = {
  error: undefined,
  loading: false,
  exportFileTypes: {},
  submitting: false,
  exportFileData: undefined,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.GENERIC_EXPORT_GET_EXPORTFILETYPE: {
      return {
        ...state,
        exportFileTypes: payload.Data,
      };
    }
    case types.GENERIC_EXPORT_GET_FILE:
      return { ...state, exportFileData: payload };
    case types.GENERIC_EXPORT_CLEAR_ERROR:
      return {
        ...state,
        error: undefined,
      };
    case types.GENERIC_EXPORT_ERROR:
      if (has(payload, 'data.Errors') && payload.data.Errors.length > 0) {
        const error = payload.data.Errors[0];
        return {
          ...state,
          error,
        };
      }
      return {
        ...state,
        error: {
          Title: 'Error',
          Message:
            'An error occurred while retrieving the export. Please try again',
        },
      };
    case types.GENERIC_EXPORT_SET_LOADING: {
      return {
        ...state,
        loading: payload,
      };
    }
    case types.GENERIC_EXPORT_SET_SUBMITTING: {
      return {
        ...state,
        submitting: payload,
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/genericexport/state/monthlyexport/reducer.js